/*
上线步骤
修改 myrequest.js 里的baseURL //上线
上传压缩 到/www/wwwroot/dist;#vue项目的打包后的dist
css 文件 拷贝到 /www/wwwroot/TymatApp/public css; 保留其他原有文件
js 文件 拷贝到 /www/wwwroot/TymatApp/public js; 保留其他原有文件

*/
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './common/gj.js'
import utils from './common/utils.js'

import 'element-ui/lib/theme-chalk/index.css';

Vue.config.productionTip = false

import {
  Button,
  ButtonGroup,
  Select,
  Option,
  Input,
  Tooltip,
  Carousel,
  CarouselItem,
  // Icon,
  Backtop,
  Pagination,
  Dialog,
  Form,
  FormItem,
  Tabs,
  TabPane,
  Table,
  TableColumn,
  Message,
  Calendar,
  // Popover,
  // Radio,
  // RadioGroup,
  // RadioButton,
} from 'element-ui';

//type : success/warning/info/error
Vue.prototype.$elMessage = function (msg,t,issc=true,time=4000,offset=100) {
  Message({
    message: msg,
    type: t,
    showClose:issc,
    duration:time,
    offset:offset
  })
}

Vue.prototype.utils=utils;

Vue.use(Button);
Vue.use(ButtonGroup);
Vue.use(Select);
Vue.use(Option);
Vue.use(Input);
Vue.use(Tooltip);
Vue.use(Carousel);
Vue.use(CarouselItem);
// Vue.use(Icon);
Vue.use(Backtop);
Vue.use(Pagination);
Vue.use(Dialog);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Calendar);

// Vue.use(Popover);
// Vue.use(Radio);
// Vue.use(RadioGroup);
// Vue.use(RadioButton);

router.beforeEach((to, from, next) => {
  if(from.meta.keepAlive){
    const ele = document.querySelector(from.meta.scrollelename)
    const scrolltop = ele?ele.scrollTop:0
    from.meta.scrollTop = scrolltop
  }
  next()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
